export const getMemberReviews = async ($axios, product, page) => {
  try {
    const { data } = await $axios.get(
      `/api/catalog/reviews/${product.product_id}/`,
      {
        params: { page },
      },
    )
    return data.results
  } catch (e) {
    console.error('Failed fetching reviews', e)
    throw e
  }
}
